<router-outlet></router-outlet>
<ngx-spinner size="medium" [type]="'ball-fussion'"></ngx-spinner>